import React,{useEffect} from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel';
import FormCheckbox from '../../../library/form/components/FormCheckbox';
import FormWrapper from '../../../library/form/components/FormWrapper';

const ProfileShorthandMain = (props) => {
    const { formObject, viewData, formAction, closeModel } = props;

    const onSuccess = ()=>{
        closeModel();
    }

    const initialiseOnFormAction = () => {
        if(formAction && formAction.action){
            if (formAction.action === 'Save') {
                //fire form action with action id = save
                let saveAction = { actionId: "save", actionParam: { showModeID: 'sh' }, containerKey: "", onSuccess: onSuccess };
                formObject.onFormAction(saveAction, "", "");
            }
            else if (formAction.action === 'Cancel') {
                //fire form action with action id = cancel
                let cancelAction = { actionId: "cancel", actionParam: { showModeID: 'sh' }, containerKey: "", onSuccess: onSuccess };
                formObject.onFormAction(cancelAction, "", "");
            }
        }
    }

    useEffect(initialiseOnFormAction, [formAction]);

    if(!viewData)
        return(null);

    return (
        <div className="uiEditableContent uiShortHand">
            <div className="uiCol">
                <ul className="uiHeaderTwoCol">
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "company" }} value="Account Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" autofocus className=""
                            action={{ InputType: "input", paramName: "company", actionId: "refresh", actionParam: { updateContact: 1, editSource: "company" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "parentProfile" }} value="Parent ID" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                            action={{ InputType: "ac", paramName: "parentProfile", acMethod: "ParentProfileName", acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1 } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refCode" }} value="Reference Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="refCodeTxt" className="uiInput"
                            action={{ InputType: "input", paramName: "refCode" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileCategory" }} value="Category 1" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "profileCategory", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} value="Category 2" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "profileCategory2", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refChannel" }} value="Channel" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "refChannel", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "addType" }} value="Address Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "addType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "streeAdd1" }} value="Street Address" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "streeAdd1" }}
                        />
                        <span className="uiLbl"></span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "streeAdd2" }}
                        />
                        <span className="uiLbl"></span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "streeAdd3" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "town" }} value="City / Town" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "town" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "state" }} value="State" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "state" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "country" }} value="Country" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "country", acMethod: "Country" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "pincode" }} value="Postal Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="" action={{ InputType: "input", paramName: "pincode" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "landmark" }} value="Landmark" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="" action={{ InputType: "input", paramName: "landmark" }} />
                    </li>
                </ul>
            </div>
            <div className="uiCol">
                <ul className="uiHeaderTwoCol">
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "conType" }} value="Contact Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "conType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "conTitle" }} value="Title" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "ac", paramName: "conTitle", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "firstName" }} value="First Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "firstName" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "middleName" }} value="Middle Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "middleName" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastName" }} value="Last Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "lastName" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "landline1" }} value="Landline" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "landline1" }}
                        />
                        <span className="uiLbl"></span>
                        <FormInput formObject={formObject} rowKey="" className="uiSpacer10"
                            action={{ InputType: "input", paramName: "landline2" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} value="Mobile" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "mobile1" }}
                        />
                        <span className="uiLbl"></span>
                        <FormInput formObject={formObject} rowKey="" className="uiSpacer10"
                            action={{ InputType: "input", paramName: "mobile2" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "whatsApp" }} value="Whatsapp No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "whatsApp" }}
                        />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email1" }} value="Email" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "input", paramName: "email1" }}
                        />
                        <span className="uiLbl"></span>
                        <FormInput formObject={formObject} rowKey="" className="uiSpacer10"
                            action={{ InputType: "input", paramName: "email2" }}
                        />
                    </li>
                    <li>
                        <span style={{ width: "125px" }} className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isCompany" }} value="Is Company" />
                        </span>
                        <div style={{ width: "auto", display: 'inline-block' }} className="uiRow uiSpacer" id="sendNotify" >
                            <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isCompany" }} />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default withView(ProfileShorthandMain, "proComp", "")